import React from "react";
import AdmLessonPlanCompletionReport from "../../components/AdminTabs/AdmLessonPlanCompletionReport/AdmLessonPlanCompletionReport";

const LessonPlanCompletionReport = () => {
  return (
    <div>
      <AdmLessonPlanCompletionReport />
    </div>
  );
};

export default LessonPlanCompletionReport;
